import { render, staticRenderFns } from "./ButtonGroups.vue?vue&type=template&id=8de48b30"
import script from "./ButtonGroups.vue?vue&type=script&lang=js"
export * from "./ButtonGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports